import React from "react";
import { Card, CardHeader, CardBody, Spinner } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { threatCard, threatCardHeader, threatCardBody, threatIconChip } from "./cardStyles";

const ORANGE_COLORS = {
  primary: '#FF5B00',
  dark: '#e85a28',
  darker: '#d14d1f',
  light: '#ff8c61',
  lighter: '#ffb399',
  subtle: '#fff5f0',
  muted: '#ffe8dd',
};

const AlertsOverTime = ({ data, loading }) => {
  if (loading) {
    return (
      <Card 
        className="h-100"
        style={{ 
          border: '1px solid rgba(255, 107, 53, 0.2)', 
          backgroundColor: 'transparent',
          borderRadius: '8px'
        }}
      >
        <CardHeader className="bg-light">
          <div className="d-flex align-items-center gap-3">
            <div style={threatIconChip()}>
              <i className="ri-line-chart-line" style={{ color: "var(--vz-primary)", fontSize: 16 }}></i>
            </div>
            <h5 className="card-title mb-0">Alerts Trend</h5>
          </div>
        </CardHeader>
        <CardBody className="d-flex justify-content-center align-items-center" style={{ minHeight: "250px" }}>
          <Spinner style={{ color: ORANGE_COLORS.primary }} />
        </CardBody>
      </Card>
    );
  }

  const chartData = data || [];
  const totalAlerts = chartData.reduce((sum, d) => sum + (d.value || 0), 0);

  const options = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: "Poppins, sans-serif"
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: "smooth",
      width: 3,
      colors: [ORANGE_COLORS.primary]
    },
    xaxis: {
      categories: chartData.map(d => d.date),
      labels: {
        rotate: -45,
        style: {
          colors: '#858d98',
          fontSize: '11px'
        }
      },
      axisBorder: {
        color: 'rgba(255, 107, 53, 0.1)'
      }
    },
    yaxis: {
      title: {
        text: "Alert Count",
        style: {
          color: '#858d98',
          fontSize: '12px',
          fontWeight: 500
        }
      },
      labels: {
        style: {
          colors: '#858d98'
        }
      }
    },
    colors: [ORANGE_COLORS.primary],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [0, 90, 100],
        gradientToColors: [ORANGE_COLORS.lighter]
      }
    },
    grid: {
      borderColor: 'rgba(255, 107, 53, 0.1)',
      strokeDashArray: 4
    },
    tooltip: {
      theme: 'dark',
      y: {
        formatter: (val) => `${val} alert${val !== 1 ? 's' : ''}`
      },
      style: {
        fontSize: '12px'
      }
    },
    markers: {
      size: 0,
      hover: {
        size: 5,
        sizeOffset: 3
      }
    }
  };

  const series = [{
    name: "Alerts",
    data: chartData.map(d => d.value)
  }];

  return (
      <Card 
        className="h-100"
        style={{ 
          ...threatCard
        }}
      >
      <CardHeader style={threatCardHeader}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <div style={threatIconChip()}>
              <i className="ri-line-chart-line" style={{ color: "var(--vz-primary)", fontSize: 16 }}></i>
            </div>
            <h5 className="card-title mb-0">Alerts Trend</h5>
          </div>
          {totalAlerts > 0 && (
            <span 
              className="badge" 
              style={{ 
                backgroundColor: 'rgba(255, 107, 53, 0.1)', 
                color: ORANGE_COLORS.primary,
                border: `1px solid ${ORANGE_COLORS.primary}`,
                fontSize: '11px'
              }}
            >
              {totalAlerts} total
            </span>
          )}
        </div>
      </CardHeader>
      <CardBody style={threatCardBody}>
        {chartData.length > 0 ? (
          <ReactApexChart options={options} series={series} type="area" height={250} />
        ) : (
          <div className="text-center py-5">
            <div className="mx-auto mb-3" style={threatIconChip()}>
              <i className="ri-line-chart-line" style={{ color: "var(--vz-primary)", fontSize: 16 }}></i>
            </div>
            <p className="text-muted mb-0">No activity data available</p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default AlertsOverTime;
